import { useCallback, useEffect, useState } from "react";
import { CommonModalWrap, OneList } from "../../styles/common";
import { useQueryClient } from "react-query";
import CommonModalBar from "../common/CommonModalBar";
import styled from "styled-components";
import theme from "../../styles/theme";
import { Button, TextField } from "@mui/material";
import { useSetCounter } from "../../interfaces/carsClass";
import { MODAL_QUERY_NM } from "../../interfaces/modal";

const CounterDetail = ({mode, ccid, counters, onClick}) => {

    const [popOpen, setPopOpen] = useState(false);
    const [target, setTarget] = useState();

    const handleItemClick = (item) => {
        setTarget(item);
        onClick(item.cnt_no)
    }

    const handlePopClose = () => {
        setTarget();
        setPopOpen(false);
    }

    return (
        <div className="list">
            <OneList>
                <ul className="titleLine">
                    <li>
                        <span/>
                        <span>카운터</span>
                    </li>
                </ul>
                <ul className="descArea">
                {counters && counters.map((item,index)=>{
                    return (
                        <li key={index} className={'descLiItem '+(target && target.cnt_no === item.cnt_no ? 'selected' : '')} onClick={()=>handleItemClick(item)}>
                            <span/>
                            <span>{item.cnt_nm}</span>
                        </li>
                    )
                })}
                </ul>
            </OneList>
            {mode !== 'VIEW' &&
            <div style={{display:'flex',gap:'0.25rem',justifyContent:'space-between',alignItems:'center'}}>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>{setTarget();setPopOpen(true)}}>추가</Button>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>setPopOpen(true)}>수정</Button>
            </div>
            }
            {popOpen && <CounterPop ccid={ccid} target={target} close={handlePopClose} />}
        </div>
    )
}

const DetailWindow = styled.div`
    position: relative;
    background: ${theme.color.white[100]};
    width: 50%;
    height: 16rem;
    border-radius: 18px;
    padding: 1rem 1rem;
`;

const MainBody = styled.div`
    padding: 1.5rem 0rem 1.5rem 0rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    overflow:auto;
    height: calc(16rem - 2rem - 40px);

    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
    }
`;

const ButtonBox = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 40px;
    gap: 8px;
`;

const CounterPop = ({ccid, target, close}) => {

    const queryClient = useQueryClient();

    const [counter, setCounter] = useState();

    const { mutate } = useSetCounter();

    useEffect(()=>{
        setCounter(target);
    },[target])

    const handleSubsClick = useCallback((updateItem) => {
        const temp = {
            mode: updateItem.cnt_no>0 ? 'PUT':'POST',
            ...updateItem,
            ccid: ccid
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:(updateItem.cnt_no>0 ? '수정':'등록')+'하였습니다.',
                            height:'20vh',
                        }
                    )
                    close();
                }
            }
            )
    })

    const handleValueChange = (id, val) => {
        const temp  = {...counter,[id]:val}
        setCounter(temp);
    }

    const handleCloseClick = () => {
        close(false);
    }

    return (
        <CommonModalWrap style={{zIndex:1300}}>
            <DetailWindow>
                <CommonModalBar title={(target) ? '카운터 정보' : '카운터 등록'} close={handleCloseClick}/>
                <MainBody>
                    <div className="row" >
                        <TextField 
                            id='cnt_nm' 
                            label='카운터명' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={counter ? counter.cnt_nm : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                    </div>
                    <ButtonBox>
                        <Button variant="contained" onClick={()=>handleSubsClick(counter)}>등록</Button>
                    </ButtonBox>
                </MainBody>
            </DetailWindow>
        </CommonModalWrap>
    )

}

export default CounterDetail;